(() => {
  const config = window.PanchbhootFastrr || {};
  const indiaTimeZones = new Set(['Asia/Kolkata', 'Asia/Calcutta']);
  let timeZone = '';

  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (_error) {
    timeZone = '';
  }

  const isActive = Boolean(config.enabled) && (!config.indiaOnly || indiaTimeZones.has(timeZone));
  if (!isActive) return;

  function activateMount(mount) {
    if (!(mount instanceof HTMLElement) || mount.dataset.pbFastrrActivated === 'true') return;

    const type = mount.dataset.pbFastrrType;
    if (!type) return;

    mount.classList.add('shiprocket-headless');
    mount.dataset.type = type;
    mount.dataset.pbFastrrActivated = 'true';
  }

  function activateWithin(root) {
    if (root instanceof HTMLElement && root.matches('[data-pb-fastrr-mount]')) {
      activateMount(root);
    }

    root.querySelectorAll?.('[data-pb-fastrr-mount]').forEach(activateMount);
  }

  activateWithin(document);

  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) activateWithin(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
